export { default as AdminToolBar } from "./AdminToolBar";



// WEBPACK FOOTER //
// ./src/modules/admin/components/index.ts